<template>
  <span>
    <button
      class="btn btn-default"
      id="addGroupBtn"
      @click="showAddForm('open')"
    >
      <font-awesome-icon :icon="faPlus" />
    </button>
    <div id="addGroupForm" v-if="addGroupForm">
      <input
        type="text"
        class="form-control col-md-5"
        maxlength="21"
        @keyup="checkName()"
        v-model="addGroupName"
        placeholder="폴더명"
      />
      <button
        class="btn btn-default"
        :disabled="addGroupName.length < 1"
        @click="addGroup()"
      >
        추가
      </button>
      <button class="btn btn-default" @click="showAddForm('close')">
        취소
      </button>
    </div>
  </span>
</template>
<script>
import Urls from "@/common/urls";
import Apiroot from "@/common/apiroot";
import eventbus from "@/store/modules/devEventBus";

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {faPlus} from "@fortawesome/free-solid-svg-icons";

export default {
  name: "UserAddGroup",
  components : {
    FontAwesomeIcon,
  },
  data() {
    return {
      addGroupForm: false,
      addGroupName: "",

      faPlus,
    };
  },
  computed: {
    userStore() {
      return this.$store.state.userStore;
    },
  },
  methods: {
    showAddForm(tag) {
      if (tag == "open") {
        this.addGroupForm = !this.addGroupForm;
      }
      if (tag == "close") {
        this.addGroupForm = false;
      }
      this.addGroupName = "";
    },
    addGroup() {
      const name = this.addGroupName.replace(/^\s+|\s+$/gm, "");

      if (name == "" || name == null) {
        alert("폴더명을 입력해 주세요.");
      } else if (name == "홈") {
        alert("다른 폴더명을 입력해 주세요.");
      } else {

        this.showAddForm("close")

        var param = { userCode: this.$store.state.userStore.userCode, groupName: name };
        this.api.createGroup(param).then((res) => {
          console.log("createGroup res : ", res);
          if (res["code"] == 0) {
            eventbus.$emit("groupList");
          }
        });

      }
    },
    getGroupList() {

      var param = { userCode: this.userStore.userCode };
      this.$store.dispatch("getGroupList", {
        paths: Apiroot.group + Urls.getGroupList,
        params: param,
      });
    },
    checkName() {
      var len = 0;
      var name = this.addGroupName

      for(var i=0; i<name.length; i++) {
        if(escape(name.charAt(i)).length == 6) {
          len++;
        }
        len++;
      }

      if(len > 21) {
        console.log(name.substr(0, 21))
        this.$store.dispatch("changeWorkflowName", name.substr(0, 21));
      }
    }
  },
};
</script>
